import React from "react";
import { ShareNetwork, WhatsappLogo, EnvelopeSimple, ChatText, LinkSimple } from "@phosphor-icons/react";
import { DropdownMenu, DropdownMenuTrigger, DropdownMenuContent, DropdownMenuItem } from "./ui/dropdown-menu";
import { toast } from "sonner";

export default function ShareMenu({ url, title = "EventVexa", text, trigger, testid = "share-menu", align = "end" }) {
  const shareUrl = url || (typeof window !== "undefined" ? window.location.href : "");
  const msg = text || title;
  const canNative = typeof navigator !== "undefined" && !!navigator.share;

  const stop = (e) => { e?.preventDefault?.(); e?.stopPropagation?.(); };

  const native = async (e) => { stop(e); try { await navigator.share({ title, text: msg, url: shareUrl }); } catch { /* cancelled */ } };
  const wa = (e) => { stop(e); window.open(`https://wa.me/?text=${encodeURIComponent(`${msg} ${shareUrl}`)}`, "_blank"); };
  const email = (e) => { stop(e); window.open(`mailto:?subject=${encodeURIComponent(title)}&body=${encodeURIComponent(`${msg}\n${shareUrl}`)}`); };
  const sms = (e) => { stop(e); window.open(`sms:?&body=${encodeURIComponent(`${msg} ${shareUrl}`)}`); };
  const copy = async (e) => { stop(e); try { await navigator.clipboard.writeText(shareUrl); toast.success("Link copied."); } catch { toast.error("Couldn't copy link."); } };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>{trigger}</DropdownMenuTrigger>
      <DropdownMenuContent align={align} onClick={(e) => e.stopPropagation()} data-testid={`${testid}-content`}>
        {canNative && <DropdownMenuItem onClick={native} data-testid={`${testid}-native`}><ShareNetwork size={16} className="mr-2" /> Share…</DropdownMenuItem>}
        <DropdownMenuItem onClick={wa} data-testid={`${testid}-whatsapp`}><WhatsappLogo size={16} className="mr-2 text-emerald-600" /> WhatsApp</DropdownMenuItem>
        <DropdownMenuItem onClick={email} data-testid={`${testid}-email`}><EnvelopeSimple size={16} className="mr-2 text-navy" /> Email</DropdownMenuItem>
        <DropdownMenuItem onClick={sms} data-testid={`${testid}-sms`}><ChatText size={16} className="mr-2 text-amber-600" /> SMS</DropdownMenuItem>
        <DropdownMenuItem onClick={copy} data-testid={`${testid}-copy`}><LinkSimple size={16} className="mr-2" /> Copy link</DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
